export default __webpack_public_path__ + "static/Graphik-Medium-Web-19c99ce15efeea421fa0cf5c9b8f7d81.woff2";